import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { ObjectType } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { OfferLocation } from '@/helpers/offer-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
// need to import this immediately because it's above the fold and could cause CLS
import ListOffer from '@/features/buybox/components/list/ListOffer.vue';
import { provide } from 'vue';

import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';

import { BuyboxRegularOffer } from '@/features/buybox/types/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedListBuyBox',
  props: {
    promotedOffers: null,
    objectType: null,
    title: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	promotedOffers: BuyboxRegularOffer[];
	objectType: ObjectType;
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
};



const { tc } = useI18n();
useProvideClickoutPlacement('promoted_buybox');

provide('offerLocation', OfferLocation.PROMOTED_BUYBOX);

return { __sfc: true,props, tc, ListOffer }
}

})